
export default function Top() {
  return (
    <div className='flex justify-center items-center h-full sticky top-0 z-10'>
      <img src={require('../../assets/prof1.JPG')} className='w-full h-screen object-cover grayscale' />
    </div>

  )
}
